import { render, staticRenderFns } from "./ProfileInfoForm.vue?vue&type=template&id=90723cbc"
import script from "./ProfileInfoForm.vue?vue&type=script&lang=ts"
export * from "./ProfileInfoForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileInfoForm.vue?vue&type=style&index=0&id=90723cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports